import axios from "axios";
import Button from "components/ui/Button";
import Modal from "components/ui/Modal";
import { showToast } from "components/ui/toast";
import { useState } from "react";

const SolicitorCall = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    number: "",
    solicitorName: "",
    solicitorEmail: "",
    propertyId: "",
    propertyAddress: "",
    clientName: "",
  });

  const handleSetData = (key, value) => {
    setData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
  };

  const handleAiCall = async () => {
    const isDataValid = Object.values(data).every(
      (value) => value.trim() !== ""
    );

    if (!isDataValid) {
      return showToast("error", "Please fill all input");
    }

    try {
      setLoading(true); // Set loading to true before making the API call
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/admin/call/make`,
        data
      );
      if (response.data.success) {
        return showToast("success", "Test Call Initiated");
      } else {
        return showToast("error", "Something went wrong");
      }
    } catch (error) {
      console.error("Error ", error);
      return showToast("error", "Something went wrong");
    } finally {
      setLoading(false); // Set loading to false once the API call is completed
    }
  };

  return (
    <>
      <div className="col-span-6 flex flex-col justify-between">
        <label className="form-label">
          Solicitor Mobile Number ( Include Country Code: +61 )
        </label>
        <input
          type="text"
          className="form-input border border-mediumgray"
          value={data.number}
          onChange={(e) => handleSetData("number", e.target.value)}
        />
      </div>
      <div className="col-span-6 flex flex-col justify-between">
        <label className="form-label">Solicitor Name</label>
        <input
          type="text"
          className="form-input border border-mediumgray"
          value={data.solicitorName}
          onChange={(e) => handleSetData("solicitorName", e.target.value)}
        />
      </div>
      <div className="col-span-6 flex flex-col justify-between">
        <label className="form-label">Solicitor Email</label>
        <input
          type="text"
          className="form-input border border-mediumgray"
          value={data.solicitorEmail}
          onChange={(e) => handleSetData("solicitorEmail", e.target.value)}
        />
      </div>
      <div className="col-span-6 flex flex-col justify-between">
        <label className="form-label">Property ID</label>
        <input
          type="text"
          className="form-input border border-mediumgray"
          value={data.propertyId}
          onChange={(e) => handleSetData("propertyId", e.target.value)}
        />
      </div>
      <div className="col-span-6 flex flex-col justify-between">
        <label className="form-label">Property Address</label>
        <input
          type="text"
          className="form-input border border-mediumgray"
          value={data.propertyAddress}
          onChange={(e) => handleSetData("propertyAddress", e.target.value)}
        />
      </div>
      <div className="col-span-6 flex flex-col justify-between">
        <label className="form-label">Client Name</label>
        <input
          type="text"
          className="form-input border border-mediumgray"
          value={data.clientName}
          onChange={(e) => handleSetData("clientName", e.target.value)}
        />
      </div>

      <p>
        Example Property ID and Property Address below, you can use any one from
        it <br />
        <span className="text-xs text-darkergray">
          1) PropertyId: 673c32637bd482d34a9488c1, PropertyAddress: 43 Rona
          Street, Peakhurst <br />
          2) PropertyId: 6711dff26988f0dfefc2f559, PropertyAddress: 93 Clarke
          Street, Peakhurst
        </span>
      </p>

      {/* Button */}
      <div className="flex flex-col items-center">
        <Button
          onClick={handleAiCall}
          disabled={loading}
          loading={loading}
          className="w-fit black-button text-white px-4 py-2 rounded-md"
        >
          Test Call
        </Button>
      </div>
    </>
  );
};

const AgentCall = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    number: "+61415778969",
    contractorId: "674cb080c71ae1f14735a057",
    eventId: "680a25aa024e0f63f3525d37",
    eventName: "Photos",
    eventAccess: "Owner occupied",
    eventDate: "2025-05-16T12:00:00.000+00:00",
    agentName: "Joyce",
    agentEmail: "joyce.boustani@ausrealty.com.au",
    propertyId: "673c32637bd482d34a9488c1",
    propertyAddress: "43 Rona Street, Peakhurst",
    suburb: "Peakhurst",
  });

  const handleSetData = (key, value) => {
    setData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
  };

  const handleAiCall = async () => {
    const isDataValid = Object.values(data).every(
      (value) => value.trim() !== ""
    );

    if (!isDataValid) {
      return showToast("error", "Please fill all input");
    }

    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/admin/call/agent/make`,
        data
      );
      if (response.data.success) {
        return showToast("success", "Test Call Initiated");
      } else {
        return showToast("error", "Something went wrong");
      }
    } catch (error) {
      console.error("Error ", error);
      return showToast("error", "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {[
        {
          label: "Solicitor Mobile Number (Include Country Code: +61)",
          key: "number",
        },
        { label: "Contractor ID", key: "contractorId" },
        { label: "Event ID", key: "eventId" },
        { label: "Event Name", key: "eventName" },
        { label: "Event Access", key: "eventAccess" },
        { label: "Event Date", key: "eventDate" },
        { label: "Agent Name", key: "agentName" },
        { label: "Agent Email", key: "agentEmail" },
        { label: "Property ID", key: "propertyId" },
        { label: "Property Address", key: "propertyAddress" },
        { label: "Suburb", key: "suburb" },
      ].map(({ label, key }) => (
        <div key={key} className="col-span-6 flex flex-col justify-between">
          <label className="form-label">{label}</label>
          <input
            type="text"
            className="form-input border border-mediumgray"
            value={data[key]}
            onChange={(e) => handleSetData(key, e.target.value)}
          />
        </div>
      ))}

      <p>
        Example Property ID and Property Address below, you can use any one from
        it <br />
        <span className="text-xs text-darkergray">
          1) PropertyId: 673c32637bd482d34a9488c1, PropertyAddress: 43 Rona
          Street, Peakhurst <br />
          2) PropertyId: 6711dff26988f0dfefc2f559, PropertyAddress: 93 Clarke
          Street, Peakhurst
        </span>
      </p>

      {/* Button */}
      <div className="flex flex-col items-center mt-4">
        <Button
          onClick={handleAiCall}
          disabled={loading}
          loading={loading}
          className="w-fit black-button text-white px-4 py-2 rounded-md"
        >
          Test Call
        </Button>
      </div>
    </>
  );
};

const AiCall = () => {
  const [isSolicitorModalOpen, setIsSolicitorModalOpen] = useState(false);
  const [isAgentModalOpen, setIsAgentModalOpen] = useState(false);

  return (
    <div className="container mx-auto p-4 max-w-lg">
      <div className="flex gap-4 justify-center">
        <Button
          onClick={() => setIsSolicitorModalOpen(true)}
          className="black-button"
        >
          Test Call Solicitor
        </Button>

        <Button
          onClick={() => setIsAgentModalOpen(true)}
          className="black-button"
        >
          Test Call Agent
        </Button>
      </div>

      <Modal
        isOpen={isSolicitorModalOpen}
        onClose={() => setIsSolicitorModalOpen(false)}
        title="AI test call"
        className="max-w-2xl"
      >
        <SolicitorCall />
      </Modal>
      <Modal
        isOpen={isAgentModalOpen}
        onClose={() => setIsAgentModalOpen(false)}
        title="AI test call"
        className="max-w-2xl"
      >
        <AgentCall />
      </Modal>
    </div>
  );
};

export default AiCall;
